import { Select } from 'peach/components'
import { getAddressName } from 'peach/helpers'
import { useParams } from 'peach/router'

import { useInternalListContactsForBorrower } from 'core/types'

const ContactAddressSelect = (props) => {
  const { companyId, personId } = useParams<{
    companyId?: string
    personId?: string
  }>()

  const { data: contacts, isLoading } = useInternalListContactsForBorrower({
    companyId,
    personId,
    query: { contactType: 'address' },
  })

  const options = _.map(contacts, ({ id, address }) => ({
    value: id,
    label: getAddressName(address),
  }))

  return <Select {...props} disabled={isLoading} options={options} />
}

export default ContactAddressSelect
